module.exports = __webpack_public_path__ + "static/images/containers/Challenges/components/Status/images/gold_right_1.f2c7c435.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Challenges/components/Status/images/gold_right_1.png
// module id = 2862
// module chunks = 11